import type { ToolPermissionsCatalog } from '../types/mcpPermissions';
import { APIClient } from 'vince-core/api/apiClient';
import { getServiceBaseUrl } from 'vince-core/utils/env';

const baseUrl = getServiceBaseUrl('/api-vince-mcp/v1/api/');

export async function getToolCatalog (): Promise<ToolPermissionsCatalog> {
    return await APIClient<ToolPermissionsCatalog>(`${baseUrl}discovery/tool-permissions`);
}
